<template>
  <v-container fill-height class="content">
    <v-layout align-center justify-center column fill-height @click="redirectToQrcode">
      <QrCode size="100"/>
      <h2 class="display-1 font-weight-light text-xs-center">Leia o código do responsável</h2>
    </v-layout>
  </v-container>
</template>

<script>
import QrCode from '@/components/icons/QrCode'

export default {
  components: {
    QrCode
  },

  methods: {
    redirectToQrcode () {
      this.$router.push('/qr')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content
    max-width max-content
</style>
